/* unplugin-vue-components disabled */import script from "./PlayerContractCareerEndNotification.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlayerContractCareerEndNotification.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__